import { useEffect, useState, type ReactNode } from "react";
import { GfButton, GfModal } from "../ui/GfUi";

/**
 * 段階を進める前の確認。チェックボックス付き（requireCheck=true ならチェックしないと実行できない）。
 * - 段階6→7/8: 「PR/タイアップ表記を確認した」必須（景表法ステマ規制）
 * - 段階3→4: 「フォームURLをコピーする」（任意）
 * - 段階7→8: チェックなし
 */
export function AdvanceConfirm({
  open,
  title,
  message,
  checkLabel,
  requireCheck,
  defaultChecked = false,
  confirmLabel,
  busy,
  onConfirm,
  onClose,
  children,
}: {
  open: boolean;
  title: ReactNode;
  message?: ReactNode;
  checkLabel?: string;
  requireCheck?: boolean;
  defaultChecked?: boolean;
  confirmLabel: string;
  busy?: boolean;
  onConfirm: (checked: boolean) => void;
  onClose: () => void;
  children?: ReactNode;
}) {
  const [checked, setChecked] = useState(defaultChecked);
  useEffect(() => {
    if (open) setChecked(defaultChecked);
  }, [open, defaultChecked]);
  const blocked = busy || (!!requireCheck && !checked);
  return (
    <GfModal
      open={open}
      title={title}
      onClose={onClose}
      width={440}
      footer={
        <>
          <GfButton onClick={onClose} disabled={busy}>
            やめる
          </GfButton>
          <GfButton variant="primary" disabled={blocked} onClick={() => onConfirm(checked)}>
            {busy ? "処理中…" : confirmLabel}
          </GfButton>
        </>
      }
    >
      {message && <div className="gf-confirm-msg">{message}</div>}
      {children}
      {checkLabel && (
        <label className="gf-check">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
          <span>
            {checkLabel}
            {requireCheck ? "（必須）" : ""}
          </span>
        </label>
      )}
    </GfModal>
  );
}
